import type { CharacterMapping } from "../types";

export const KATAKANA_MAPPINGS: CharacterMapping[] = [
  { id: "ka_a", character: "ア", romanizations: ["a"], pronunciation: "ah" },
  { id: "ka_i", character: "イ", romanizations: ["i"], pronunciation: "ee" },
  { id: "ka_u", character: "ウ", romanizations: ["u"], pronunciation: "oo" },
  { id: "ka_e", character: "エ", romanizations: ["e"], pronunciation: "eh" },
  { id: "ka_o", character: "オ", romanizations: ["o"], pronunciation: "oh" },
  {
    id: "ka_ka",
    character: "カ",
    romanizations: ["ka", "ca"],
    pronunciation: "kah",
  },
  { id: "ka_ki", character: "キ", romanizations: ["ki"], pronunciation: "kee" },
  { id: "ka_ku", character: "ク", romanizations: ["ku"], pronunciation: "koo" },
  { id: "ka_ke", character: "ケ", romanizations: ["ke"], pronunciation: "keh" },
  { id: "ka_ko", character: "コ", romanizations: ["ko"], pronunciation: "koh" },
  { id: "ka_sa", character: "サ", romanizations: ["sa"], pronunciation: "sah" },
  {
    id: "ka_shi",
    character: "シ",
    romanizations: ["shi"],
    pronunciation: "shee",
  },
  { id: "ka_su", character: "ス", romanizations: ["su"], pronunciation: "soo" },
  { id: "ka_se", character: "セ", romanizations: ["se"], pronunciation: "seh" },
  { id: "ka_so", character: "ソ", romanizations: ["so"], pronunciation: "soh" },
  { id: "ka_ta", character: "タ", romanizations: ["ta"], pronunciation: "tah" },
  {
    id: "ka_chi",
    character: "チ",
    romanizations: ["chi"],
    pronunciation: "chee",
  },
  {
    id: "ka_tsu",
    character: "ツ",
    romanizations: ["tsu"],
    pronunciation: "tsoo",
  },
  { id: "ka_te", character: "テ", romanizations: ["te"], pronunciation: "teh" },
  { id: "ka_to", character: "ト", romanizations: ["to"], pronunciation: "toh" },
  { id: "ka_na", character: "ナ", romanizations: ["na"], pronunciation: "nah" },
  { id: "ka_ni", character: "ニ", romanizations: ["ni"], pronunciation: "nee" },
  { id: "ka_nu", character: "ヌ", romanizations: ["nu"], pronunciation: "noo" },
  { id: "ka_ne", character: "ネ", romanizations: ["ne"], pronunciation: "neh" },
  { id: "ka_no", character: "ノ", romanizations: ["no"], pronunciation: "noh" },
  { id: "ka_ha", character: "ハ", romanizations: ["ha"], pronunciation: "hah" },
  { id: "ka_hi", character: "ヒ", romanizations: ["hi"], pronunciation: "hee" },
  { id: "ka_fu", character: "フ", romanizations: ["fu"], pronunciation: "foo" },
  { id: "ka_he", character: "ヘ", romanizations: ["he"], pronunciation: "heh" },
  { id: "ka_ho", character: "ホ", romanizations: ["ho"], pronunciation: "hoh" },
  { id: "ka_ma", character: "マ", romanizations: ["ma"], pronunciation: "mah" },
  { id: "ka_mi", character: "ミ", romanizations: ["mi"], pronunciation: "mee" },
  { id: "ka_mu", character: "ム", romanizations: ["mu"], pronunciation: "moo" },
  { id: "ka_me", character: "メ", romanizations: ["me"], pronunciation: "meh" },
  { id: "ka_mo", character: "モ", romanizations: ["mo"], pronunciation: "moh" },
  { id: "ka_ya", character: "ヤ", romanizations: ["ya"], pronunciation: "yah" },
  { id: "ka_yu", character: "ユ", romanizations: ["yu"], pronunciation: "yoo" },
  { id: "ka_yo", character: "ヨ", romanizations: ["yo"], pronunciation: "yoh" },
  { id: "ka_ra", character: "ラ", romanizations: ["ra"], pronunciation: "rah" },
  { id: "ka_ri", character: "リ", romanizations: ["ri"], pronunciation: "ree" },
  { id: "ka_ru", character: "ル", romanizations: ["ru"], pronunciation: "roo" },
  { id: "ka_re", character: "レ", romanizations: ["re"], pronunciation: "reh" },
  { id: "ka_ro", character: "ロ", romanizations: ["ro"], pronunciation: "roh" },
  { id: "ka_wa", character: "ワ", romanizations: ["wa"], pronunciation: "wah" },
  { id: "ka_wo", character: "ヲ", romanizations: ["wo"], pronunciation: "woh" },
  { id: "ka_n", character: "ン", romanizations: ["n"], pronunciation: "n" },
];

export const HIRAGANA_MAPPINGS: CharacterMapping[] = [
  { id: "hi_a", character: "あ", romanizations: ["a"], pronunciation: "ah" },
  { id: "hi_i", character: "い", romanizations: ["i"], pronunciation: "ee" },
  { id: "hi_u", character: "う", romanizations: ["u"], pronunciation: "oo" },
  { id: "hi_e", character: "え", romanizations: ["e"], pronunciation: "eh" },
  { id: "hi_o", character: "お", romanizations: ["o"], pronunciation: "oh" },
  {
    id: "hi_ka",
    character: "か",
    romanizations: ["ka", "ca"],
    pronunciation: "kah",
  },
  { id: "hi_ki", character: "き", romanizations: ["ki"], pronunciation: "kee" },
  { id: "hi_ku", character: "く", romanizations: ["ku"], pronunciation: "koo" },
  { id: "hi_ke", character: "け", romanizations: ["ke"], pronunciation: "keh" },
  { id: "hi_ko", character: "こ", romanizations: ["ko"], pronunciation: "koh" },
  { id: "hi_sa", character: "さ", romanizations: ["sa"], pronunciation: "sah" },
  {
    id: "hi_shi",
    character: "し",
    romanizations: ["shi"],
    pronunciation: "shee",
  },
  { id: "hi_su", character: "す", romanizations: ["su"], pronunciation: "soo" },
  { id: "hi_se", character: "せ", romanizations: ["se"], pronunciation: "seh" },
  { id: "hi_so", character: "そ", romanizations: ["so"], pronunciation: "soh" },
  { id: "hi_ta", character: "た", romanizations: ["ta"], pronunciation: "tah" },
  {
    id: "hi_chi",
    character: "ち",
    romanizations: ["chi"],
    pronunciation: "chee",
  },
  {
    id: "hi_tsu",
    character: "つ",
    romanizations: ["tsu"],
    pronunciation: "tsoo",
  },
  { id: "hi_te", character: "て", romanizations: ["te"], pronunciation: "teh" },
  { id: "hi_to", character: "と", romanizations: ["to"], pronunciation: "toh" },
  { id: "hi_na", character: "な", romanizations: ["na"], pronunciation: "nah" },
  { id: "hi_ni", character: "に", romanizations: ["ni"], pronunciation: "nee" },
  { id: "hi_nu", character: "ぬ", romanizations: ["nu"], pronunciation: "noo" },
  { id: "hi_ne", character: "ね", romanizations: ["ne"], pronunciation: "neh" },
  { id: "hi_no", character: "の", romanizations: ["no"], pronunciation: "noh" },
  { id: "hi_ha", character: "は", romanizations: ["ha"], pronunciation: "hah" },
  { id: "hi_hi", character: "ひ", romanizations: ["hi"], pronunciation: "hee" },
  { id: "hi_fu", character: "ふ", romanizations: ["fu"], pronunciation: "foo" },
  { id: "hi_he", character: "へ", romanizations: ["he"], pronunciation: "heh" },
  { id: "hi_ho", character: "ほ", romanizations: ["ho"], pronunciation: "hoh" },
  { id: "hi_ma", character: "ま", romanizations: ["ma"], pronunciation: "mah" },
  { id: "hi_mi", character: "み", romanizations: ["mi"], pronunciation: "mee" },
  { id: "hi_mu", character: "む", romanizations: ["mu"], pronunciation: "moo" },
  { id: "hi_me", character: "め", romanizations: ["me"], pronunciation: "meh" },
  { id: "hi_mo", character: "も", romanizations: ["mo"], pronunciation: "moh" },
  { id: "hi_ya", character: "や", romanizations: ["ya"], pronunciation: "yah" },
  { id: "hi_yu", character: "ゆ", romanizations: ["yu"], pronunciation: "yoo" },
  { id: "hi_yo", character: "よ", romanizations: ["yo"], pronunciation: "yoh" },
  { id: "hi_ra", character: "ら", romanizations: ["ra"], pronunciation: "rah" },
  { id: "hi_ri", character: "り", romanizations: ["ri"], pronunciation: "ree" },
  { id: "hi_ru", character: "る", romanizations: ["ru"], pronunciation: "roo" },
  { id: "hi_re", character: "れ", romanizations: ["re"], pronunciation: "reh" },
  { id: "hi_ro", character: "ろ", romanizations: ["ro"], pronunciation: "roh" },
  { id: "hi_wa", character: "わ", romanizations: ["wa"], pronunciation: "wah" },
  { id: "hi_wo", character: "を", romanizations: ["wo"], pronunciation: "woh" },
  { id: "hi_n", character: "ん", romanizations: ["n"], pronunciation: "n" },
];
